import { schema } from 'normalizr';

export const resultSetEntity = new schema.Entity('result-sets');
